import { render, staticRenderFns } from "./SearchMaterialSimple.vue?vue&type=template&id=22b56658"
import script from "./SearchMaterialSimple.vue?vue&type=script&lang=js"
export * from "./SearchMaterialSimple.vue?vue&type=script&lang=js"
import style0 from "./SearchMaterialSimple.vue?vue&type=style&index=0&id=22b56658&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports